/* eslint-disable @typescript-eslint/no-unused-vars */
import $ from 'jquery';
import React from 'react';
import { identity, extend, map, isArray, each, noop, isEmpty } from 'underscore';
import PropTypes from 'prop-types';
import { buildLegacyI18n } from '@bingads-webui/build-legacy-i18n';
import { CampaignAdgroupSelector } from '@bingads-webui-campaign-react/campaign-adgroup-selector';
import { CampaignSelector } from '@bingads-webui-campaign-react/campaign-selector';
import { getEntityFromScope } from '@bingads-webui/edm-campaign';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { withUiBlock } from '@bingads-webui/uiblocker';
import { ComponentSettings, ThemeFluent } from '@bingads-webui-theme-2018/theme-fluent';
import { perfMarkerPropTypes } from '@bingads-webui/performance-marker';
import { getCampaignAdgroupMultiSelectorStyle } from './campaign-adgroup-selector-style';
import { processEdmResult, processEdmResultAccount } from './util';
import { legacyI18nMap } from './legacy-i18n-map';

const CAMPAIGN_PAGESIZE = 10;
const ADGROUP_PAGESIZE = 6;
class UnstyledCampaignAdgroupSelectorEdm extends React.Component {
  constructor(props) {
    super(props);
    this.campaign = {
      onFetch: this.fetchCampaign,
      onSelect: props.onSelectCampaign,
      pageSize: CAMPAIGN_PAGESIZE,
      containerClassName: 'campaign-entity-container',
    };
    this.adgroup = {
      onFetch: this.fetchAdgroup,
      onSelect: props.onSelectAdGroup,
      pageSize: ADGROUP_PAGESIZE,
      containerClassName: 'adgroup-entity-container',
    };
    this.i18nLegacy = buildLegacyI18n(this.props.i18n, [legacyI18nMap]);
    this.campaignId = this.props.scope.values.campaignId;
    this.selfRef = React.createRef();
  }

  onSelectDone = (items) => {
    if (items.length > 0) {
      this.props.onApply(map(items, item => JSON.stringify(item)));
    }
  }

  fetchCampaign = ({
    query = '', pageNumber = 0, pageSize = CAMPAIGN_PAGESIZE,
  }) => {
    const { currentEntity } = getEntityFromScope(this.props.scope);
    const filter = this.props.campaignFilterCustomizer ?
      this.props.campaignFilterCustomizer(query) :
      `contains(Name, '${query}')`;

    return currentEntity.Campaigns.get({
      filter: {
        where: filter,
      },
      skip: pageSize * pageNumber,
      top: pageSize,
      select: ['Id', 'Name', 'Status'],
    }).fetch()
      .then(data => processEdmResult(data))
      .catch(e => processEdmResult(null, true))
      .finally(withUiBlock($(`.${this.campaign.containerClassName}`, this.selfRef.current)));
  }

  fetchAdgroup = ({
    query = '', pageNumber = 0, pageSize = CAMPAIGN_PAGESIZE, scopeParentItem = null,
  }) => {
    const filter = this.props.adGroupFilterCustomizer ?
      this.props.adGroupFilterCustomizer(query) :
      `contains(Name, '${query}')`;
    this.campaignId = scopeParentItem ? scopeParentItem.Id : this.props.scope.values.campaignId;
    const { currentEntity } = getEntityFromScope({
      values: {
        cid: this.props.scope.values.cid,
        aid: this.props.scope.values.aid,
        campaignId: this.campaignId,
      },
    });

    return currentEntity.AdGroups.get({
      filter: {
        where: filter,
      },
      skip: pageSize * pageNumber,
      top: pageSize,
      select: ['Id', 'Name', 'Status', 'Campaign'],
    }).fetch()
      .then(data => processEdmResult(data))
      .catch(e => processEdmResult(null, true))
      .finally(withUiBlock($(`.${this.adgroup.containerClassName}`, this.selfRef.current)));
  }

  fetchAccount = ({
    query = '', pageNumber = 0, pageSize = CAMPAIGN_PAGESIZE,
  }) => {
    const { currentEntity } = getEntityFromScope(this.props.scope);
    // Filter out deleted accounts, only fetch expert account (AccountMode = 0)
    const filter = this.props.accountFilterCustomizer ?
      this.props.accountFilterCustomizer(query) :
      `contains(Name, '${query}') and AccountMode eq 0 and AccountInactiveReasons/all(r:r/Reason ne Enum.AccountInactiveReasonCode'Deleted')`;

    return currentEntity.Accounts.get({
      filter: {
        where: filter,
      },
      skip: pageSize * pageNumber,
      top: pageSize,
      select: ['Id', 'Name', 'Status'],
    }).fetch()
      .then(data => processEdmResultAccount(data))
      .catch(e => processEdmResultAccount(null, true));
  };

  render() {
    const { aid, campaignId, adGroupId } = this.props.scope.values;
    const className = `container ${this.props.classes.campaignAdgroupMultiSelector}`;

    if (isArray(this.props.value)) {
      each(this.props.value, (item) => {
        extend(item, {
          name: item.name || item.Name,
        });
      });
    }

    // Account selector, only include expert accounts under customer
    if (this.props.isCampaignMode && !aid) {
      return (
        <div className={className} ref={this.selfRef}>
          <CampaignSelector
            pageSize={CAMPAIGN_PAGESIZE}
            i18n={this.i18nLegacy}
            i18nLegacy={this.i18nLegacy}
            fetch={this.fetchAccount}
            onSelectDone={this.onSelectDone}
            onSelect={identity}
            isMultiMode={this.props.isMultiMode}
            selectedItemsForMultiMode={this.props.value}
            onSelectCancel={this.props.onSelectCancel}
            withDropdownMenu={this.props.withDropdownMenu}
            perfMarker={this.props.perfMarker}
            stringKeys={
              {
                listHeader: 'AccountSelector_List_Header',
                selectEntities: 'AccountSelector_SelectAccounts',
                emptyListContent: 'EmptyList_Content',
                resultHeader: 'AccountSelector_Result_List_Header',
                actionBar: 'Result_Action_Bar',
              }
            }
          />
        </div>
      );
    }

    if (this.props.isCampaignMode && !campaignId) {
      return (
        <div className={className} ref={this.selfRef}>
          <CampaignSelector
            pageSize={CAMPAIGN_PAGESIZE}
            i18n={this.i18nLegacy}
            i18nLegacy={this.i18nLegacy}
            fetch={this.fetchCampaign}
            onSelectDone={this.onSelectDone}
            onSelect={identity}
            isMultiMode={this.props.isMultiMode}
            selectedItemsForMultiMode={this.props.value}
            onSelectCancel={this.props.onSelectCancel}
            withDropdownMenu={this.props.withDropdownMenu}
            perfMarker={this.props.perfMarker}
            stringKeys={
              {
                listHeader: 'CampaignSelector_List_Header',
                selectEntities: 'CampaignSelector_SelectCampaigns',
                emptyListContent: 'EmptyList_Content',
                resultHeader: 'CampaignSelector_Result_List_Header',
                actionBar: 'Result_Action_Bar',
              }
            }
          />
        </div>
      );
    }

    if (!this.props.isCampaignMode && campaignId && !adGroupId) {
      return (
        <div className={className} ref={this.selfRef}>
          <CampaignSelector
            pageSize={CAMPAIGN_PAGESIZE}
            i18n={this.i18nLegacy}
            i18nLegacy={this.i18nLegacy}
            fetch={this.fetchAdgroup}
            onSelectDone={this.onSelectDone}
            onSelect={identity}
            isMultiMode={this.props.isMultiMode}
            selectedItemsForMultiMode={this.props.value}
            onSelectCancel={this.props.onSelectCancel}
            withDropdownMenu={this.props.withDropdownMenu}
            perfMarker={this.props.perfMarker}
            stringKeys={
              {
                listHeader: 'AdGroupSelector_List_Header',
                selectEntities: 'AdGroupSelector_SelectAdGroups',
                emptyListContent: 'EmptyList_Content',
                resultHeader: 'AdGroupSelector_Result_List_Header',
                actionBar: 'Result_Action_Bar',
              }
            }
          />
        </div>
      );
    }

    if (!this.props.isCampaignMode && !campaignId && !adGroupId) {
      return (
        <div className={className} ref={this.selfRef}>
          <CampaignAdgroupSelector
            campaign={this.campaign}
            adgroup={this.adgroup}
            i18n={this.i18nLegacy}
            i18nLegacy={this.i18nLegacy}
            isMultiMode={this.props.isMultiMode}
            onSelectDone={this.onSelectDone}
            selectedCampaign={isArray(this.props.value) && !isEmpty(this.props.value) ? {
              name: this.props.value[0].campaignName,
            } : null}
            selectedAdgroupsForMultiMode={this.props.value}
            onSelectCancel={this.props.onSelectCancel}
            withDropdownMenu={this.props.withDropdownMenu}
          />
        </div>
      );
    }
    return null;
  }
}

const getCampaignAdgroupMultiSelectorStyles = (_, { palette = ThemeFluent.palette }) => extend({
  campaignAdgroupMultiSelector: extend(
    {},
    ComponentSettings.entitySelectorStyle({ palette }),
    extend(
      {},
      ComponentSettings.paginationStyle({ palette }),
      { '& .ba-pagination': ComponentSettings.paginationStyle({ palette })['& .ba-pagination, .dlb-pager-container, .pagination-control'] }
    ),
    getCampaignAdgroupMultiSelectorStyle()
  ),
});

export const CampaignAdgroupSelectorEdm = withDefaultStyles(
  UnstyledCampaignAdgroupSelectorEdm,
  getCampaignAdgroupMultiSelectorStyles
);

UnstyledCampaignAdgroupSelectorEdm.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
  scope: PropTypes.shape({
    values: PropTypes.shape({
      cid: PropTypes.number.isRequired,
      aid: PropTypes.number,
      campaignId: PropTypes.number,
      adGroupId: PropTypes.number,
    }),
  }).isRequired,
  classes: PropTypes.shape({
    campaignAdgroupMultiSelector: PropTypes.string.isRequired,
  }).isRequired,
  onApply: PropTypes.func.isRequired,
  onSelectCampaign: PropTypes.func,
  onSelectAdGroup: PropTypes.func,
  onSelectCancel: PropTypes.func,
  isCampaignMode: PropTypes.bool,
  isMultiMode: PropTypes.bool,
  withDropdownMenu: PropTypes.bool,
  // this will completely replace the default campaign filter, there will be no cancatenation
  accountFilterCustomizer: PropTypes.func,
  campaignFilterCustomizer: PropTypes.func,
  adGroupFilterCustomizer: PropTypes.func,
  // eslint-disable-next-line react/forbid-prop-types
  value: PropTypes.any,
  perfMarker: perfMarkerPropTypes,
};

UnstyledCampaignAdgroupSelectorEdm.defaultProps = {
  isCampaignMode: false,
  isMultiMode: true,
  withDropdownMenu: true,
  value: null,
  accountFilterCustomizer: undefined,
  campaignFilterCustomizer: undefined,
  adGroupFilterCustomizer: undefined,
  onSelectCancel: noop,
  onSelectCampaign: identity,
  onSelectAdGroup: identity,
  perfMarker: null,
};
